import { useState } from "react";
import { api } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { PauseNotice, ScaleInput } from "./PainFatigue";
import { useI18n } from "../../i18n";

export const PainDialog = ({ open, onClose, sessionId, analytics, paused, setPaused, onStop }) => {
  const { t } = useI18n();
  const [pain, setPain] = useState(0);
  const [fatigue, setFatigue] = useState(0);
  const submit = async () => {
    const { data } = await api.post(`/sessions/${sessionId}/pain`, { pain, fatigue });
    analytics?.setReported(pain, fatigue);
    setPaused(data.pause_recommended);
    onClose();
  };
  return (
    <>
      <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
        <DialogContent className="max-w-sm rounded-3xl" data-testid="pain-dialog">
          <DialogHeader><DialogTitle className="font-display text-2xl">Comment te sens-tu ?</DialogTitle></DialogHeader>
          <ScaleInput label={t("painNow")} value={pain} onChange={setPain} testId="pain-slider-during" />
          <ScaleInput label={t("fatigueNow")} value={fatigue} onChange={setFatigue} testId="fatigue-slider-during" />
          <button data-testid="pain-submit-button" onClick={submit} className="h-14 rounded-full bg-brand text-base font-extrabold text-white">Valider</button>
        </DialogContent>
      </Dialog>
      {paused && (
        <div className="absolute inset-0 z-50 flex items-center bg-[#061A2E]/70 p-4" data-testid="pain-pause-overlay">
          <div className="w-full rounded-3xl bg-white p-6">
            <PauseNotice text={t("pauseMsg")} />
            <button data-testid="pause-stop-button" onClick={onStop} className="mt-4 h-16 w-full rounded-full bg-red-600 text-lg font-extrabold text-white">Arrêter la séance</button>
            <button data-testid="pause-resume-button" onClick={() => setPaused(false)} className="mt-2 h-14 w-full rounded-full text-sm font-semibold text-slate-600">
              Reprendre (avec l'accord de mon professionnel de santé)
            </button>
          </div>
        </div>
      )}
    </>
  );
};
